var _ = require("lodash");
var $ = require("./gl");
module.exports = _.mapValues($, function (value, key) {
  return key;
});